import { useState } from 'react';

import { getDuration } from '@/utils/get-duration';

import useInterval from './use-interval';

const useDuration = (startTime: Date) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_tick, setTick] = useState(0);
  const dateDiff = new Date(+new Date() - +startTime);

  useInterval(() => setTick((prev) => prev + 1), 1000);

  return getDuration(dateDiff);
};

export default useDuration;
